// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39jhW","footer":"styles_footer__39Ylx","passCodeTooltip":"styles_passCodeTooltip__3AXbV"};